import type { SVGProps } from 'react';
const LogoDsKo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 158 48"
    {...props}
  >
    <path
      fill="#231815"
      d="M4.238 24.951a.48.48 0 0 1-.487-.474v-7.253c0-.26.22-.474.487-.474h13.33c.267 0 .487.213.487.474v1.772c0 .261-.22.474-.487.474H7.13a.19.19 0 0 0-.192.186v2.376c0 .103.09.186.192.186h10.437c.267 0 .487.212.487.473v1.786c0 .261-.22.474-.487.474h-4.773a.343.343 0 0 0-.343.337v1.064c0 .179.151.337.343.337h8.434c.275 0 .487.213.487.474v1.786c0 .26-.22.48-.487.48H.487A.483.483 0 0 1 0 28.95v-1.786c0-.261.22-.474.487-.474H8.92a.337.337 0 0 0 .336-.337v-1.064a.34.34 0 0 0-.336-.337zM40.6 22.018a.337.337 0 0 1-.342-.33V17.08a.48.48 0 0 0-.487-.474h-2.208a.48.48 0 0 0-.487.474v20.53c0 .26.22.474.487.474h2.208a.48.48 0 0 0 .487-.474V25.17c0-.185.15-.33.343-.33h3.106a.48.48 0 0 0 .487-.474V22.48a.47.47 0 0 0-.487-.467H40.6zM85.816 17.087a.48.48 0 0 0-.487-.474h-2.215a.484.484 0 0 0-.494.474v20.53c0 .26.22.474.494.474h2.215a.48.48 0 0 0 .487-.474zM109.088 33.44a.48.48 0 0 0-.486.475v1.875c0 .268.219.474.486.474h19.872a.48.48 0 0 0 .487-.474v-1.875a.48.48 0 0 0-.487-.474zM95.669 35.103c0 .103.082.185.185.185h9.854c.267 0 .487.213.487.474v1.813c0 .261-.22.474-.487.474H92.96a.48.48 0 0 1-.486-.474v-6.353c0-.261.22-.474.486-.474h2.222c.268 0 .487.213.487.474zM28.827 17.011c-3.257 0-5.904 2.892-5.904 7.089 0 4.196 2.647 7.088 5.904 7.088s5.904-2.83 5.904-7.088c0-4.259-2.64-7.089-5.904-7.089m0 11.443c-1.44 0-2.606-1.36-2.606-4.354 0-2.995 1.166-4.355 2.606-4.355s2.605 1.477 2.605 4.355c0 2.877-1.165 4.354-2.605 4.354M74.138 17.011c-3.264 0-5.904 2.892-5.904 7.089 0 4.196 2.64 7.088 5.904 7.088s5.904-2.83 5.904-7.088c0-4.259-2.647-7.089-5.904-7.089m0 11.443c-1.44 0-2.605-1.36-2.605-4.354 0-2.995 1.165-4.355 2.605-4.355s2.606 1.477 2.606 4.355c0 2.877-1.166 4.354-2.606 4.354M105.715 16.654h-2.201a.48.48 0 0 0-.487.474v4.485c0 .186-.151.33-.336.33h-1.865c-.185 0-.309-.165-.35-.316-.658-2.768-2.887-4.568-5.54-4.568-3.175 0-5.747 2.576-5.747 6.312s2.572 6.313 5.747 6.313c2.667 0 4.916-1.786 5.561-4.61.041-.171.151-.302.329-.302h1.872c.185 0 .336.152.336.337v7.033c0 .261.212.474.487.474h2.201a.49.49 0 0 0 .493-.474V17.128a.483.483 0 0 0-.493-.474zM94.929 26.826c-1.413 0-2.551-1.085-2.551-3.468s1.138-3.476 2.55-3.476c1.413 0 2.552 1.182 2.552 3.476s-1.139 3.468-2.551 3.468M10.861 29.972c-4.279 0-7.193 2.246-7.193 5.014S6.582 40 10.861 40s7.193-2.246 7.193-5.014-2.914-5.014-7.193-5.014m0 7.52c-2.345 0-3.826-1.256-3.826-2.513s1.48-2.514 3.826-2.514 3.826 1.257 3.826 2.514-1.48 2.514-3.826 2.514M123.447 30.096c-1.508-1.697-3.655-4.918-4.903-7.144a.17.17 0 0 0-.164-.11.17.17 0 0 0-.165.11l-3.805 7.171a.5.5 0 0 1-.439.268h-2.702a.49.49 0 0 1-.432-.714l6.501-11.972c.123-.24.274-.302.541-.302h2.771c.144 0 .39.123.274.426l-.85 1.586c-.083.158-.124.227 0 .46 1.097 2.191 4.333 7.226 7.254 10.118.137.137.151.37-.13.377h-3.182c-.329 0-.466-.165-.576-.281zM66.363 22.018h-3.114a.33.33 0 0 1-.336-.33V17.08a.48.48 0 0 0-.486-.474h-2.208a.48.48 0 0 0-.487.474v11.333c-2.578-2.892-5.122-6.704-6.11-8.53-.123-.234-.089-.303-.014-.46l.796-1.587c.103-.303-.151-.426-.295-.426h-2.77c-.26 0-.419.055-.528.295l-6.055 11.972a.5.5 0 0 0-.048.226.506.506 0 0 0 .5.488h2.702c.192 0 .357-.11.425-.275l3.545-7.17c.042-.076.096-.11.172-.11s.117.034.158.11c1.33 2.225 3.593 5.453 5.163 7.143.11.117.254.281.583.281h1.776v7.233c0 .26.22.474.487.474h2.208a.48.48 0 0 0 .486-.474V25.164c0-.185.151-.33.337-.33h3.113a.48.48 0 0 0 .486-.474v-1.888a.47.47 0 0 0-.486-.467z"
    />
    <path fill="#009A53" d="M154.262 17.781h-2.441v-2.446z" />
    <path fill="#008342" d="M151.821 15.335h2.441v2.446z" />
    <path fill="#009143" d="M154.262 17.78h-2.441v2.446z" />
    <path fill="#57B76F" d="M154.262 27.569h-2.441v-2.446z" />
    <path fill="#64BA6F" d="M156.703 30.014h-2.441v-2.446z" />
    <path fill="#48A86D" d="M154.262 27.568h-2.441v2.446z" />
    <path fill="#66BF97" d="M151.821 30.014h2.441v-2.446z" />
    <path fill="#71C7D1" d="M154.262 32.46h-2.441v-2.447z" />
    <path fill="#2EB6AA" d="M151.821 30.013h2.441v2.446z" />
    <path fill="#3DABA4" d="M156.703 30.013h-2.441v2.446z" />
    <path fill="#1BB8CE" d="M154.262 32.459h-2.441v2.445z" />
    <path fill="#44B13F" d="M139.615 22.678h2.441v-2.452z" />
    <path fill="#7FBE26" d="M139.615 22.678h2.441v2.445z" />
    <path fill="#009740" d="M144.497 17.781h2.441v-2.446z" />
    <path fill="#22AC38" d="M144.497 17.78h2.441v2.446z" />
    <path fill="#45B035" d="M146.938 20.226h-2.441v-2.445z" />
    <path fill="#00A040" d="M142.057 20.226h2.441v-2.445z" />
    <path fill="#008842" d="M149.38 17.781h-2.442v-2.446z" />
    <path fill="#00A33E" d="M149.38 17.78h-2.442v2.446z" />
    <path fill="#5CB531" d="M144.498 22.678h-2.441v-2.452z" />
    <path fill="#1EAC4B" d="M142.057 20.226h2.441v2.452z" />
    <path
      fill="#43B149"
      d="M146.938 20.226h-2.441v2.452zM144.498 22.678h-2.441v2.445z"
    />
    <path fill="#00A040" d="M146.938 15.335h2.442v2.446z" />
    <path fill="#45B035" d="M149.38 17.781h2.441v-2.446z" />
    <path fill="#009143" d="M151.821 15.335h-2.441v2.446z" />
    <path fill="#00984F" d="M149.38 17.78h2.441v2.446z" />
    <path fill="#00A040" d="M151.821 20.226h-2.441v-2.445z" />
    <path fill="#43B149" d="M146.938 20.226h2.442v-2.445z" />
    <path fill="#6FBA2E" d="M144.497 22.678h2.441v-2.452z" />
    <path fill="#6EBA44" d="M144.497 22.678h2.441v2.445z" />
    <path fill="#89C125" d="M146.938 25.123h-2.441v-2.445z" />
    <path fill="#9DC814" d="M142.057 25.123h2.441v-2.445z" />
    <path fill="#8EC43E" d="M149.38 22.678h-2.442v-2.452z" />
    <path fill="#22AC38" d="M146.938 20.226h2.442v2.452z" />
    <path fill="#51B44E" d="M151.821 20.226h-2.441v2.452z" />
    <path fill="#7FBE26" d="M151.821 25.123h-2.441v-2.445z" />
    <path fill="#44B13F" d="M149.38 22.678h-2.442v2.445z" />
    <path fill="#9DC814" d="M146.938 25.123h2.442v-2.445z" />
    <path fill="#7FBE26" d="M142.057 25.123h2.441v2.446z" />
    <path fill="#7CC16D" d="M144.497 27.569h2.441v-2.446z" />
    <path fill="#5BB647" d="M146.938 25.123h-2.441v2.446z" />
    <path fill="#57B76F" d="M144.497 27.568h2.441v2.446z" />
    <path fill="#43B149" d="M149.38 27.569h-2.442v-2.446z" />
    <path fill="#7DC058" d="M146.938 25.123h2.442v2.446z" />
    <path fill="#6CBB5A" d="M149.38 27.569h2.441v-2.446z" />
    <path fill="#8EC43E" d="M151.821 25.123h-2.441v2.446z" />
    <path fill="#4DBBAA" d="M149.38 27.568h2.441v2.446z" />
    <path fill="#7DC058" d="M151.821 30.014h-2.441v-2.446z" />
    <path fill="#59B75B" d="M149.38 27.568h-2.442v2.446z" />
    <path fill="#87CAAC" d="M146.938 30.014h2.442v-2.446z" />
    <path fill="#01A3C1" d="M144.497 32.46h2.441v-2.447z" />
    <path fill="#00A5E3" d="M144.497 32.459h2.441v2.445z" />
    <path fill="#0093D4" d="M146.938 34.904h-2.441v-2.446z" />
    <path fill="#20AEE5" d="M142.057 34.904h2.441v-2.446z" />
    <path fill="#1BB8CE" d="M149.38 32.46h-2.442v-2.447z" />
    <path fill="#4DBBAA" d="M146.938 30.013h2.442v2.446z" />
    <path fill="#3AB483" d="M149.38 32.46h2.441v-2.447z" />
    <path fill="#3DABA4" d="M151.821 30.013h-2.441v2.446z" />
    <path fill="#00A4C5" d="M149.38 32.459h2.441v2.445z" />
    <path fill="#0099D9" d="M151.821 34.904h-2.441v-2.446z" />
    <path fill="#009FC1" d="M149.38 32.459h-2.442v2.445z" />
    <path fill="#20AEE5" d="M146.938 34.904h2.442v-2.446z" />
    <path fill="#0079C3" d="M144.498 37.356h-2.441v-2.452z" />
    <path fill="#0087BE" d="M142.057 34.904h2.441v2.452z" />
    <path fill="#0075C2" d="M144.497 37.356h2.441v-2.452z" />
    <path fill="#0097E0" d="M146.938 34.904h-2.441v2.452z" />
    <path fill="#008CD6" d="M149.38 37.356h-2.442v-2.452z" />
    <path fill="#187FC4" d="M146.938 34.904h2.442v2.452z" />
    <path fill="#008CCF" d="M151.821 34.904h-2.441v2.452z" />
    <path
      fill="#0068B7"
      d="M140.637 37.356a.428.428 0 0 1-.302-.728l1.715-1.718v2.446z"
    />
    <path
      fill="#007440"
      d="M155.681 15.335a.428.428 0 0 1 .302.729l-1.721 1.717v-2.446h1.419"
    />
    <path fill="#D01126" d="M134.726 8h2.441v2.446z" />
    <path fill="#E72410" d="M137.167 10.446h-2.441V8z" />
    <path fill="#C81528" d="M134.726 8h-2.441v2.446z" />
    <path fill="#D80C18" d="M132.285 10.446h2.441V8z" />
    <path fill="#E72410" d="M142.056 10.446h-2.441V8z" />
    <path fill="#E8380D" d="M139.615 8h-2.448v2.446z" />
    <path fill="#D80C24" d="M137.167 10.446h2.448V8z" />
    <path fill="#E94709" d="M132.285 10.445h2.441v2.446z" />
    <path fill="#EA5504" d="M134.726 12.891h2.441v-2.446z" />
    <path fill="#DA3915" d="M137.167 10.445h-2.441v2.446z" />
    <path fill="#E8380D" d="M134.726 12.89h2.441v2.446z" />
    <path fill="#E72410" d="M139.615 12.891h-2.448v-2.446z" />
    <path fill="#E83820" d="M137.167 10.445h2.448v2.446z" />
    <path fill="#E8382F" d="M139.615 12.891h2.441v-2.446z" />
    <path fill="#E94709" d="M142.056 10.445h-2.441v2.446z" />
    <path fill="#E94709" d="M139.615 12.89h2.441v2.446z" />
    <path fill="#E8380D" d="M142.056 15.336h-2.441V12.89z" />
    <path fill="#E60039" d="M139.615 12.89h-2.448v2.446z" />
    <path fill="#ED6C00" d="M137.167 15.336h2.448V12.89z" />
    <path fill="#F18D00" d="M134.726 17.781h2.441v-2.446z" />
    <path fill="#ED6C00" d="M134.726 17.78h2.441v2.446z" />
    <path fill="#F39800" d="M137.167 20.226h-2.441v-2.445z" />
    <path fill="#F08300" d="M132.285 20.226h2.441v-2.445z" />
    <path fill="#EB6100" d="M139.615 17.781h-2.448v-2.446z" />
    <path fill="#E94709" d="M137.167 15.335h2.448v2.446z" />
    <path fill="#ED6C00" d="M139.615 17.781h2.441v-2.446z" />
    <path fill="#EA5504" d="M142.056 15.335h-2.441v2.446z" />
    <path fill="#F08300" d="M139.615 17.78h2.441v2.446z" />
    <path fill="#F39800" d="M142.056 20.226h-2.441v-2.445z" />
    <path fill="#EE7800" d="M139.615 17.78h-2.448v2.446z" />
    <path fill="#F6AB00" d="M137.167 20.226h2.448v-2.445z" />
    <path fill="#F08300" d="M134.726 22.678h-2.441v-2.452z" />
    <path
      fill="#F39800"
      d="M132.285 20.226h2.441v2.452zM134.726 22.678h2.441v-2.452z"
    />
    <path
      fill="#F6AB00"
      d="M137.167 20.226h-2.441v2.452zM139.615 22.678h-2.448v-2.452z"
    />
    <path fill="#F39800" d="M137.167 20.226h2.448v2.452z" />
    <path fill="#F18D00" d="M142.056 20.226h-2.441v2.452z" />
    <path fill="#DF003A" d="M144.497 12.891h-2.441v-2.446z" />
    <path fill="#E72418" d="M146.938 15.336h-2.441V12.89z" />
    <path fill="#E83820" d="M144.497 12.89h-2.441v2.446z" />
    <path fill="#EA5504" d="M142.056 15.336h2.441V12.89z" />
    <path fill="#EB6100" d="M144.497 17.781h-2.441v-2.446z" />
    <path fill="#E9473F" d="M142.056 15.335h2.441v2.446z" />
    <path fill="#EA5504" d="M146.938 15.335h-2.441v2.446z" />
    <path fill="#EB6100" d="M144.497 17.78h-2.441v2.446z" />
    <path
      fill="#F5A200"
      d="M130.872 22.678a.428.428 0 0 1-.301-.728l1.714-1.717v2.445z"
    />
    <path
      fill="#B81C22"
      d="M130.872 8a.428.428 0 0 0-.301.728l1.714 1.718V8z"
    />
  </svg>
);
export default LogoDsKo;
